export function PictureButton({ icon, label, background, onClick, disabled, testId }) {
  return (
    <button
      className="wmleye-picbtn"
      style={{ background }}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      aria-label={label}
    >
      <span className="wmleye-picbtn__icon" aria-hidden>
        {icon}
      </span>
      <span>{label}</span>
    </button>
  );
}
